module.exports = __webpack_public_path__ + "fonts/iconfont.380f2bc8.ttf";